export const selectCategories = (state) => state.categories.merchantCategories;
export const selectCategory = (state) => state.categories.category;
export const isFetchingCategories = (state) => state.categories.isFetchingMerchantCategories;